import {Component, OnInit} from '@angular/core';
import {NavBarVm} from '../../../../../view-model/nav-bar/nav-bar.vm';
import { countryConfig } from 'src/country-config/country-config';
import { PageEvent } from '../../../event-listeners/event-page/event-page.event';

@Component({
  selector: 'app-country',
  templateUrl: './country.component.html',
  styleUrls: ['./country.component.scss'],
})
export class CountryComponent implements OnInit {
  countrySelected;
  countries;
  countryConfig = countryConfig;

  constructor(private nvm: NavBarVm, private eventPage: PageEvent) { }

  ngOnInit() {
    this.countrySelected = {
      countryName: this.countryConfig.countryName,
      routeImg: this.countryConfig.routeImg
    };

    this.eventPage.eventCallAllComponentsListener.subscribe( (res: any) => {
      if (res.allComponents) {
        this.callAllComponents();
      }
    });
  }

  callAllComponents() {
    this.countries = this.nvm.getCountriesFtd();
  }

  changeCountry(country: any) {
    window.location.href = `https://www.farmatodo.com.${country.cctld}`;
  }
}
